const GTM_168_URL = 'https://load.lto.ona.bet.br/d7f5fumuhsul.js';
const GTM_168_QUERY = 'k=BRFOLyEgWDY8L0o6Jl5DQBpIQUZESxEIURodCVsPEBJCFwE%3D';

const GTM_302_INLINE_SCRIPT = `!function(){"use strict";function l(e){for(var t=e,r=0,n=document.cookie.split(";");r<n.length;r++){var o=n[r].split("=");if(o[0].trim()===t)return o[1]}}function s(e){return localStorage.getItem(e)}function u(e){return window[e]}function A(e,t){e=document.querySelector(e);return t?null==e?void 0:e.getAttribute(t):null==e?void 0:e.textContent}var e=window,t=document,r="script",n="dataLayer",o="https://server.betmassa.bet",a="",i="aokqsgyfw",c="1v=HgJEICc8RiFDMClfOyctSQFbS0lCVw8BSgQcEx4QGBwWSBsCBw%3D%3D",g="stapeUserId",v="",E="",d=!1;try{var d=!!g&&(m=navigator.userAgent,!!(m=new RegExp("Version/([0-9._]+)(.*Mobile)?.Safari.").exec(m)))&&16.4<=parseFloat(m[1]),f="stapeUserId"===g,I=d&&!f?function(e,t,r){void 0===t&&(t="");var n={cookie:l,localStorage:s,jsVariable:u,cssSelector:A},t=Array.isArray(t)?t:[t];if(e&&n[e])for(var o=n[e],a=0,i=t;a<i.length;a++){var c=i[a],c=r?o(c,r):o(c);if(c)return c}else console.warn("invalid uid source",e)}(g,v,E):void 0;d=d&&(!!I||f)}catch(e){console.error(e)}var m=e,g=(m[n]=m[n]||[],m[n].push({"gtm.start":(new Date).getTime(),event:"gtm.js"}),t.getElementsByTagName(r)[0]),v=I?"&bi="+encodeURIComponent(I):"",E=t.createElement(r),f=(d&&(i=8<i.length?i.replace(/([a-z]{8}$)/,"kp$1"):"kp"+i),!d&&a?a:o);E.async=!0,E.src=f+"/"+i+".js?"+c+v,null!=(e=g.parentNode)&&e.insertBefore(E,g)}();`;

const PROJECTS_WITH_CUSTOM_GTM = new Map([
  [168, initGTM168],
  [302, initGTM302],
]);

export const hasCustomGTM = projectId => PROJECTS_WITH_CUSTOM_GTM.has(Number(projectId));

const insertScriptInHead = script => {
  document.head.insertBefore(script, document.head.firstChild);
};

function initGTM168() {
  if (document.getElementById('gtm-script')) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'gtm.js',
    'gtm.start': new Date().getTime(),
  });

  const script = document.createElement('script');
  script.id = 'gtm-script';
  script.async = true;
  script.src = `${GTM_168_URL}?${GTM_168_QUERY}`;

  insertScriptInHead(script);
}

function initGTM302() {
  if (document.getElementById('gtm-script-302')) return;

  const script = document.createElement('script');
  script.id = 'gtm-script-302';
  script.textContent = GTM_302_INLINE_SCRIPT;

  insertScriptInHead(script);
}

export const initCustomGTM = projectId => {
  if (typeof window === 'undefined') return;

  const id = Number(projectId);

  PROJECTS_WITH_CUSTOM_GTM.get(id)?.();
};
